import { Button, Stack } from "@mui/material";
import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ConcreteLoginStrategy } from "./LoginStrategy";
import { ForcedExternalLogoutFlag } from "../ForcedExternalLogoutFlag";

export interface LoginFormOnMobileWebViewProps {
  username?: string | null;
  strategy: ConcreteLoginStrategy;
  // Not used by this component directly, but accepted to match parent prop passing
  onRegisterNewUser?: () => void;
}

export const LoginFormOnMobileWebView: FC<LoginFormOnMobileWebViewProps> = (
  props
) => {
  const { t } = useTranslation("shared-ts-ui-identity");

  const handleLoginClick = useCallback(() => {
    try {
      const baseUrl = window.location.origin;
      const currentRelative = `${window.location.pathname}${window.location.search}`;
      const returnUrl = encodeURIComponent(currentRelative);

      // Detect previous bootstrap failure and perform a one-time external-browser logout to break stale sessions
      const params = new URLSearchParams(window.location.search);
      const hadBootstrapFailure =
        params.get("login_error") === "bootstrap_failed";
      const externalLogoutAlreadyForced = ForcedExternalLogoutFlag.is();

      const loginUrl = `${baseUrl}/identity/login?externalMobileAuth=1&callback_scheme=minpipe&returnUrl=${returnUrl}`;

      if (hadBootstrapFailure && !externalLogoutAlreadyForced) {
        // Prefer the dedicated route that logs out in the external browser and then redirects back to login
        const logoutThenLogin = `${baseUrl}/identity/logout-browser?externalMobileAuth=1&callback_scheme=minpipe&returnUrl=${encodeURIComponent(
          currentRelative
        )}`;
        ForcedExternalLogoutFlag.set();
        console.log(
          "[LoginFormOnMobileWebView] Forcing external-browser logout before login:",
          logoutThenLogin
        );
        window.location.href = logoutThenLogin; // Intercepted by mobile app
        return;
      }

      console.log("[LoginFormOnMobileWebView] Navigating to:", loginUrl);
      window.location.href = loginUrl; // Intercepted by mobile app
    } catch (e) {
      console.error("[LoginFormOnMobileWebView] handleLoginClick: Error: ", e);
    }
  }, []);

  return (
    <Stack
      useFlexGap
      sx={{ flexGrow: 1, minHeight: 0, gap: 2, alignItems: "center", mt: 2 }}
    >
      <Button variant={"contained"} onClick={handleLoginClick}>
        {t("Log In")}
      </Button>
    </Stack>
  );
};
